// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1dgLG","errorLogs":"styles_errorLogs__3msxD"};